interface VideoPlayerInterface {
  url: string;
  autoPlay?: boolean;
  objectFit?: "cover" | "contain";
}

export const VideoPlayer = ({
  url,
  autoPlay,
  objectFit = "cover",
}: VideoPlayerInterface) => {
  return (
    <video
      width="100%"
      height="100%"
      controls
      autoPlay={autoPlay ? autoPlay : false}
      style={{
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
        objectFit,
        objectPosition: "center",
      }}
    >
      <source src={url} type="video/mp4" />
      Tu navegador no soporta la etiqueta de video.
    </video>
  );
};
